import React from "react";
import "./AboutNRWCSection.scss";
import { TwoColumnLayout } from "../components";
import ContentSection from "../components/ContentSection";
import SectionHeader from "../components/SectionHeader";
import ABOUT_IMAGE from "../assets/images/AboutNRWC.jpg";

const AboutNRWCSection = () => {
  const leftContent = (
    <div className="about-nrwc-section-content">
      <p>
        The National Reentry Workforce Collaborative (NRWC) is dedicated to
        supporting organizations that promote opportunities for justice-impacted
        job seekers in the workforce. By fostering collaboration, sharing best
        practices, and providing training and certification programs, NRWC aims
        to strengthen the reentry workforce field and drive economic mobility
        for individuals affected by the justice system.
      </p>
    </div>
  );

  const rightContent = (
    <div className="about-nrwc-section-right-content">
      <img src={ABOUT_IMAGE} alt="About NRWC" className="about-image" />
    </div>
  );

  return (
    <ContentSection className="about-nrwc-section">
      <SectionHeader
        title="RECOMMENDATIONS AND CONCLUSION"
        description="About NRWC"
      />
      <TwoColumnLayout leftContent={leftContent} rightContent={rightContent} />
    </ContentSection>
  );
};

export default AboutNRWCSection;
